import * as Yup from 'yup'
import { isNil } from 'ramda'

import { websiteRegex } from 'commons/website'
import { validateGsm } from 'commons/validateGsm'
import { emailSchemaValidation } from 'commons/schemaValidation'

import {
  validatePhoneNumber,
  isOnlyCountryCallingCode,
} from 'app/componentV4/Input/PhoneNumberInputV4'

export const validationSchema = (formatMessage) => {
  const textRequired = formatMessage({
    id: 'composeDialog.field.required',
  })
  return Yup.object({
    description: Yup.string().min(100).trim().required(textRequired),
    name: Yup.string().trim().required(textRequired),
    category: Yup.object().required(textRequired),
    email: emailSchemaValidation(formatMessage),
    phoneNumber: Yup.string().test(
      'is-valid-phone',
      formatMessage({ id: 'crm.form.validation.url' }),
      (value) => {
        const notHavePhoneNumber = isOnlyCountryCallingCode(value)
        if (isNil(value) || notHavePhoneNumber) return true
        return validatePhoneNumber(value)
      },
    ),
    contactUrl: Yup.string()
      .matches(
        websiteRegex,
        formatMessage({
          id: 'profile.contactUrl.formatInvalid.label',
        }),
      )
      .trim(),
    shortName: Yup.string()
      .test(
        'is-valid-shortName',
        formatMessage({ id: 'profile.info.placeSms.textfield.errorGsm.text' }),
        (value) => {
          if (value) return validateGsm('', value)
          else return true
        },
      )
      .trim()
      .max(38, formatMessage({ id: 'profile.sms.maximum.validation' })),
    address: Yup.string().trim().required(textRequired),
  })
}
